<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


   var clickMenuVertical = function() {
    var isHomePage = $('body').hasClass('template-index') || $('body').hasClass('index');
    var isDesktop = window.matchMedia('(min-width: 1025px)').matches;
    var $vMenu = $('.vertical-menu');
    var $vButton = $('.categories-title__button');
    var $nav = $('.header__menu-vertical');
    var $headerWrapper = $('.shopify-section-header-sticky'); // Roditelj koji dobija klasu scrolled-past-header

    if (isDesktop && isHomePage) {
        // Funkcija koja proverava skrol
        var checkScroll = function() {
            if ($headerWrapper.hasClass('scrolled-past-header')) {
                // --- KADA JE SKROLOVANO (STICKY) ---
                $vMenu.addClass('vertical-menu__hide').removeClass('vertical-menu__open');
                $nav.attr('style', 'display: none !important'); // Force sakrivanje
                
                // Ponovo dozvoljavamo klik ako korisnik želi da ga otvori u sticky modu
                $vButton.off('click').on('click', function(e) {
                    e.preventDefault();
                    $vMenu.toggleClass('vertical-menu__hide vertical-menu__open');
                    if($vMenu.hasClass('vertical-menu__open')) {
                        $nav.attr('style', 'display: block !important; opacity: 1; visibility: visible;');
                    } else {
                        $nav.attr('style', 'display: none !important');
                    }
                });
                $vButton.css('cursor', 'pointer');
            } else {
                // --- KADA JE NA VRHU (HOME) ---
                $vMenu.removeClass('vertical-menu__hide').addClass('vertical-menu__open');
                $nav.attr('style', 'display: block !important; opacity: 1; visibility: visible;');
                
                // Isključujemo klik na vrhu (da ostane uvek otvoren)
                $vButton.off('click').css('cursor', 'default');
            }
        };

        // Pozovi odmah i na svaki skrol
        checkScroll();
        $(window).on('scroll', checkScroll);

    } else {
        // --- OSTALE STRANICE ---
        $vButton.off('click').on('click', function(e) {
            e.preventDefault();
            $vMenu.toggleClass('vertical-menu__hide vertical-menu__open');
        });
    }
}

var initClickSubmenu = function() {
    if (window.matchMedia('(min-width: 1025px)').matches) {
        var menuSelector = '.header__menu-vertical li.dropdown > a, .header__menu-vertical li.dropdown .site-nav-list-dropdown > a';
        
        $(document).off('click', menuSelector).on('click', menuSelector, function(e) {
            var $link = $(this);
            var $parentLi = $link.closest('li.dropdown');

            if ($parentLi.find('.header__submenu, .site-nav-list-dropdown').length > 0) {
                e.preventDefault(); 
                e.stopPropagation();

                if ($parentLi.hasClass('is-active-click')) {
                    $parentLi.removeClass('is-active-click');
                } else {
                    $parentLi.siblings().removeClass('is-active-click');
                    $parentLi.addClass('is-active-click');
                }
            }
        });

        $(document).on('click', function(e) {
            if (!$(e.target).closest('.header__menu-vertical').length) {
                $('.menu-lv-1, .menu-lv-2').removeClass('is-active-click');
            }
        });
    }
};

$(document).ready(function() {
    clickMenuVertical();
    setTimeout(function(){
        initClickSubmenu();
    }, 500);
});
  
  



